import * as DisplayTypes from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { COALESCING_REFINE_BY, COALESCING_REFINE_BY_TYPE } from '../constants/constants';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import getIn from 'transmute/getIn';
import invariant from 'react-utils/invariant';
import isNumber from 'transmute/isNumber';
import { NUMBER } from 'customer-data-objects/property/PropertyTypes';
const makeNumberRefinementField = () => {
  return DSFieldRecord({
    displayType: DisplayTypes.CountDisplayType,
    refinement: true,
    type: NUMBER
  });
};
const fromNumCoalescing = (__, filter) => {
  const refinementField = makeNumberRefinementField();
  const minOccurrences = parseInt(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  getIn([COALESCING_REFINE_BY, 'minOccurrences'], filter), 10);
  const maxOccurrences = parseInt(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  getIn([COALESCING_REFINE_BY, 'maxOccurrences'], filter), 10);
  const hasMin = isNumber(minOccurrences);
  const hasMax = isNumber(maxOccurrences);
  invariant(hasMin || hasMax, `Unable to parse occurrence refinement with min: "${minOccurrences}" and max: "${maxOccurrences}"`);
  if (minOccurrences === maxOccurrences) {
    return Operators.Equal.of(refinementField, minOccurrences);
  }
  return hasMin ? Operators.GreaterOrEqual.of(refinementField, minOccurrences) : Operators.LessOrEqual.of(refinementField, maxOccurrences);
};
const FROM_COALESCE_FOR_TYPE = {
  [COALESCING_REFINE_BY_TYPE.NUM_OCCURRENCES]: fromNumCoalescing
};
const fromNumberRefinementFilter = (field, filter) => {
  const coalesceType = getIn([COALESCING_REFINE_BY, 'type'], filter);
  if (
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  Object.prototype.hasOwnProperty.call(FROM_COALESCE_FOR_TYPE, coalesceType)) {
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'unknown' cannot be used as an index type.
    return FROM_COALESCE_FOR_TYPE[coalesceType](field, filter);
  }
  return undefined;
};
export default fromNumberRefinementFilter;